import { render, staticRenderFns } from "./pic_hist.vue?vue&type=template&id=477500ca&scoped=true"
import script from "./pic_hist.vue?vue&type=script&lang=js"
export * from "./pic_hist.vue?vue&type=script&lang=js"
import style0 from "./pic_hist.vue?vue&type=style&index=0&id=477500ca&prod&lang=css"
import style1 from "./pic_hist.vue?vue&type=style&index=1&id=477500ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477500ca",
  null
  
)

export default component.exports